import { createAction, createSlice } from '@reduxjs/toolkit';

import { initialStore } from '../initial-store';

export const getGreyList = createAction('greyList/GET_LIST');

const greyListSlice = createSlice({
  initialState: initialStore.greyListPage,
  name: 'greyListPage',
  reducers: {
    removeGreyList: (state, { payload }) => {
      state.data = state.data.filter((item) => item.id !== payload.id);
    },
    setGreyList: (state, { payload }) => {
      const { count, result } = payload;
      state.data = result;
      state.count = count;
      state.isLoading = false;
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    updateGreyList: (state, { payload }) => {
      state.data = state.data.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
    }
  }
});

export const { removeGreyList, setGreyList, setLoading, updateGreyList } =
  greyListSlice.actions;

export const { reducer } = greyListSlice;
